module.exports = __webpack_public_path__ + "img/seminole.4aa66cc9.png";